export default [
    { //订单填写
        path: '/order/goodsOrder',
        name: 'GoodsOrder',
        component: () => import('@/views/order/GoodsOrder.vue'),
        meta: {
            showTab: false
        }
    },
    { //购物车
        path: '/order/shoppingCart',
        name: 'ShoppingCart',
        component: () => import('@/views/order/ShoppingCart.vue'),
        meta: {
            showTab: true
        }
    },
    { //订单支付页面 （暂时废弃）
        path: '/order/waitingPayment',
        name: 'WaitingPayment',
        component: () => import('@/views/order/WaitingPayment.vue'),
        meta: {
            showTab: false
        }
    },
    { //支付结果页面
        path: '/order/payResult',
        name: 'PayResult',
        component: () => import('@/views/order/PayResult.vue'),
        meta: {
            showTab: false
        }
    },
    { //我的订单 页面
        path: '/order/personalOrders',
        name: 'PersonalOrders',
        component: () => import('@/views/order/PersonalOrders.vue'),
        meta: {
            showTab: false
        }
    },
    { //物流页面
        path: '/order/logisticsOrder',
        name: 'LogisticsOrder',
        component: () => import('@/views/order/LogisticsOrder.vue'),
        meta: {
            showTab: false
        }
    },
    {  //订单详情页面
        path: '/order/orderDetail',
        name: 'OrderDetail',
        component: () => import('@/views/order/OrderDetail.vue'),
        meta: {
            showTab: false,
            keepAlive: false
        }
    },
];
